module.exports = __webpack_public_path__ + "static/media/collection-bird-09.548b392a.png";